import '../../../../../../vendor/typo3/cms-frontend/Resources/Public/JavaScript/default_frontend';
